import { Chart } from 'chart.js';

export function getChart(): typeof Chart {
  return Chart;
}
